// CR-0074: local attribution identifier returned by the verified auth profile.
export type TAuthUserId = string & { readonly __brand: 'AuthUserId' };
export function createAuthUserId(value: string): TAuthUserId { return value as TAuthUserId; }

/** SOURCE_DELETE permission bitmask (1 << 7) */
export const PERMISSION_SOURCE_DELETE = 128;

/**
 * Совместимая числовая проекция для ещё не перенесённых потребителей.
 * Допуск к сеансу задаёт закрытый набор EDIT_SESSION_PRIVILEGES
 * (spec/backend/changelog-undo-redo/edit-sessions.md, R03, R11).
 */
export const PERMISSION_PROJECT_EDIT = 2;

/**
 * Права областей изменения (spec/backend/invariants/rbac.md, rbac-R34).
 *
 * Значения — те же биты, что в каталоге прав продукта.
 */
/** NOTES_VIEW (1 << 9) */
export const PERMISSION_NOTES_VIEW = 512;
/** NOTES_EDIT (1 << 10) */
export const PERMISSION_NOTES_EDIT = 1024;
/** DICTIONARIES_MANAGE (1 << 11) — единое право на просмотр и изменение (rbac-R02) */
export const PERMISSION_DICTIONARIES_MANAGE = 2048;
/** BM_VIEW (1 << 12) */
export const PERMISSION_BM_VIEW = 4096;
/** BM_EDIT (1 << 13) */
export const PERMISSION_BM_EDIT = 8192;
/** MAPPING_VIEW (1 << 14) */
export const PERMISSION_MAPPING_VIEW = 16384;
/** MAPPING_EDIT (1 << 15) */
export const PERMISSION_MAPPING_EDIT = 32768;
/** FEATURE_VIEW (1 << 16) — витрины живут под правом фичи (rbac-R03) */
export const PERMISSION_FEATURE_VIEW = 65536;
/** FEATURE_EDIT (1 << 17) */
export const PERMISSION_FEATURE_EDIT = 131072;


/** CR-0074: changelog-undo-redo-edit-sessions-R11, exact twelve-grant projection. */
export const EDIT_SESSION_OPENING_PERMISSION_MASK = 2 | 32 | 1024 | 2048 | 8192 | 32768 | 131072 | 524288 | 2097152 | 4194304 | 8388608 | 16777216;
